import React, { Component } from 'react';
import NewsListItem from './NewsListItem';
import { GetData } from '../../api/Service';

class NewsList extends Component {
    constructor(Props) {
        super(Props);
        this.state = {
            news: [],
            news_det: []
        }
    }

    componentDidMount(){
        var url = "http://192.168.43.104:5000/api/news/1/20";
        /* fetch(url).then(resp => resp.json())
        .then(json => {
            this.setState({
                news: json.rows,
                news_det: json.b_arr
            })
        }); */

        GetData('api/news/1/20')
            .then(json => {
                //console.log(json);
                this.setState({
                    news: json.rows.map(el => {
                        return {
                            ...el,
                            description: JSON.parse(el.description),
                            //uploadInfo: JSON.parse(el.uploadInfo)
                        }
                    }),
                    news_det: json.b_arr
                })
            });
    }

    editClick(value){
        this.props.onEditClick(value);
    }

    onDeleteClick(id){
        this.props.onDeleteClick(id);
    }
    
    render() {
        let n = this.state.news;
        let m = n.map((nn) =>
            <NewsListItem
                key={nn.id}
                headline={nn.title}
                description={nn.description}
                postedon={nn._date_}
                editClick={this.editClick.bind(this,nn)}
                onDeleteClick={this.onDeleteClick.bind(this,nn.id)}
            />
    );
        return (
            <div className="notice-list">
                {m}
            </div>
        )
    }
}


export default NewsList;


// WEBPACK FOOTER //
// ./src/HomeComponents/News/NewsList.js